/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useRecoilState } from 'recoil';
import { getAccountInfo } from './api';
import { Account, Pharmacys } from './pages';
import { accountState } from './recoil';

const App: React.FC = React.memo(() => {
    const history = useHistory()
    const pathname = history.location.pathname

    const [account, setAccountDataState] = useRecoilState(accountState.accountDataState)
    const accountInfo = getAccountInfo()

    useEffect(() => {
        if (accountInfo?.loginSession?.mToken) {
            setAccountDataState(accountInfo)
        }
    }, [])

    useEffect(() => {
        if (accountInfo?.loginSession?.mToken) {
            if (accountInfo.loginSession.userLocalType === "ADMIN" && pathname === '/login') {
                history.push('/admin-dashboard')
            }

            if (accountInfo.loginSession.userLocalType === "PHARMACIST" && (pathname === '/search-pharmacys' || pathname === '/login')) {
                history.push('/inventory-dashboard?tab=inventories')
            }
        }

        if (!accountInfo?.loginSession?.mToken && pathname !== '/login') {
            history.push('/login')
        }
    }, [pathname, accountInfo])

    if (account?.loginSession?.mToken) {
        return <Pharmacys />
    }

    return <Account />
})

export default App